import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

type BtnProps = {
  title: string;
  type?: "button" | "submit";
  isLoading?: boolean;
  classList?: string | null;
  onClick?: Function | undefined;
  children?: React.ReactNode;
  disabled?: boolean;
};

const CustomButton = ({
  type = "button",
  isLoading = false,
  title,
  classList = "",
  onClick = undefined,
  children,
  disabled = false,
}: BtnProps) => {
  return (
    <Button
      type={type}
      className={classList ? `${classList}` : ""}
      onClick={onClick ? () => onClick() : () => {}}
      disabled={disabled}
    >
      {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
      {!isLoading && title}
      {children}
    </Button>
  );
};

export default CustomButton;
